module.exports = __webpack_public_path__ + "img/acero-inoxidable.c9d0353a.jpeg";